<template>
  <div>
    <v-card
      outlined
      :loading="loading"
      style="display: flex; flex-grow: 1; flex-direction: column"
    >
      <v-card-title class="flex-wrap">
        <div>
          <h5>{{ title }}</h5>
          <h6 class="text-muted">{{ description }}</h6>
        </div>
        <v-spacer></v-spacer>
        <slot></slot>
      </v-card-title>
      <v-card-text>
        <div
          class="d-flex justify-content-center align-items-center"
          v-if="loading"
          style="min-height: 500px"
        >
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-if="donutChartOptions.series[0] === 0"> <p class="fw-bold text-center">Dövizli Satış Bulunamadı</p></div>
        <div v-else>
        <apexchart
          class="apex-charts"
          height="400"
          type="donut"
          dir="ltr"
          :series="donutChartOptions.series"
          :options="donutChartOptions.chartOptions"
          v-if="!loading"
        ></apexchart>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ColumnChart",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    donutChartOptions: {
      type: Object,
      default: null
    },
    loading: {
      Type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped></style>
